export default [
    {
        icon: 'GridIcon',
        route: 'risk-procedure',
        title: 'Risk + procedure'
    },
]
